import { useContext } from "react";
import { I18NContext } from "./I18NProvider";

export function useLanguage() {
  return useContext(I18NContext).language;
}
